import { NAME_FIELD_MAX, FIRSTNAME_FIELD_MAX, LASTNAME_FIELD_MAX } from '../item/newItemForm';
import { CARD_TYPE } from '../cardType/cardTypeModule';

import { isValidEmail } from './email';
import { isRegexMatch } from './matchesRegexRule';


const AMOUNT_REGEX = /^[0-9]+.?[0-9]{0,2}$/;
const isString = value => typeof value === 'string';

const isAmountValid = (amount) => {
    if (isString(amount)) {
        return AMOUNT_REGEX.test(amount);
    }
    return typeof amount === 'number';
};

const isCardTypeValid = cardType => cardType === CARD_TYPE.PHYSICAL || cardType === CARD_TYPE.DIGITAL;

export const isBooleanValid = (boolean) => {
    if (typeof boolean === 'boolean') {
        return boolean;
    }
    if (isString(boolean)) {
        const normalizedBoolean = boolean.trim().toLowerCase();
        switch (normalizedBoolean) {
            case 'true':
                return true;
            case 'false':
                return false;
            default:
                return null;
        }
    }
    return null;
};

const getValidName = (name, maxLength) => {
    if (isString(name)) {
        if (name.length > maxLength) {
            return name.substring(0, maxLength);
        }
        return name;
    }
    return null;
};

export const validateProgramCode = programCode => (isString(programCode) ? programCode : null);

export const validateName = name => getValidName(name, NAME_FIELD_MAX);

export const validateBillingFirstName = name => getValidName(name, FIRSTNAME_FIELD_MAX);

export const validateBillingLastName = name => getValidName(name, LASTNAME_FIELD_MAX);

export const validateEmail = email => (isValidEmail(email) ? email : null);



export const validateFaceplateCode = faceplateCode => (isString(faceplateCode) ? faceplateCode : null);

export const validateAmount = amount => (isAmountValid(amount) ? parseFloat(amount) : null);

export const validateCardType = cardType => (isCardTypeValid(cardType) ? cardType : null);

export const validateSelfBuy = (isSelfBuy, isSelfBuyEnabled) => {
    if (isSelfBuyEnabled) {
        return isBooleanValid(isSelfBuy);
    }
    return null;
};

export const validateClassicGift = (isClassicGift, hasClassicCatalogs) => {
    if (hasClassicCatalogs) {
        return isBooleanValid(isClassicGift);
    }
    return null;
};

export const validateLoyaltyNumber = (validationRegex, loyaltyNumber) => {
    if (isString(loyaltyNumber)) {
        if (validationRegex) {
            return isRegexMatch(validationRegex, loyaltyNumber) ? loyaltyNumber : null;
        }
        return loyaltyNumber;
    }
    return null;
};
